<script>
import { mapState, mapActions } from "vuex";
import cryptoRandomString from "crypto-random-string";
import APIService from "@/services/api.service";

export default {
	data() {
		return {
			mode: "INSERT",
			myData: {},
			show: true,
			showImages: false,
			message: "",
			myOptions: {
				status: [
					{ text: "-", value: null },
					{ text: "Aktif", value: 1 },
					{ text: "Non Aktif", value: 0 },
				],
				kabupaten: [],
			},
			params: {},
			headers: {},
			imgDataUrl: "",
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			auth: (state) => state.auth.user,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
	},
	components: {},
	created() {
		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			console.log(parseInt(this.$route.params.id));

			this.myData = this.$store.getters["pengguna/getById"](
				parseInt(this.$route.params.id)
			);

			console.log(this.myData);

			if (this.myData) {
				this.imgDataUrl = APIService.getImagePengguna(this.myData.img);
			} else {
				this.$router.push("/pengguna");
			}
		} else {
			this.myData.uid = cryptoRandomString({
				length: 16,
				type: "distinguishable",
			});

			// this.myData.email = this.$faker().internet.email();
			// this.myData.first_name = this.$faker().name.findName();
			// this.myData.username = this.$faker().internet.userName();
			// this.myData.phone = this.$faker().phone.phoneNumber();
			// this.myData.password = "bQb1NfQXybfFUYJ";
			// this.myData.jk = "L";
			// this.myData.active = 1;
		}
		this.getLingkunganStasi();
		// this.params = { uid: this.myData.uid };
		// this.headers = APIService.getHeader();
	},
	methods: {
		// ...mapActions("pengguna", ["insert", "update"]),
		...mapActions({
			insert: "pengguna/insert",
			update: "pengguna/update",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		onSubmit() {
			if (this.mode === "INSERT") {
				this.insert(this.myData).then(() => {
					this.$router.push("/pengguna");
				});
			} else {
				this.update(this.myData).then(() => {
					this.$router.push("/pengguna");
				});
			}
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs main="Pengguna" title="Form Pengguna" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<px-card>
						<div slot="with-padding">
							<form
								@submit.prevent="onSubmit"
								v-if="show"
								id="form-data"
							>
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-6">
											<div class="form-group">
												<label>Nama</label>
												<input
													v-model="myData.first_name"
													name="nama"
													class="form-control"
													type="text"
													required
												/>
											</div>
											<div class="form-group">
												<label>Username</label>
												<input
													v-model="myData.username"
													name="username"
													class="form-control"
													type="text"
													required
												/>
											</div>
											<div
												class="form-group"
												v-if="mode === 'INSERT'"
											>
												<label>Password</label>
												<input
													v-model="myData.password"
													name="password"
													class="form-control"
													type="password"
													required
												/>
											</div>
											<div class="form-group">
												<label>Level/Hak Akses</label>
												<select
													v-model="myData.group_id"
													name="group_id"
													class="form-control"
												>
													<option value="2">Admin</option>
													<option value="3">
														Lingkungan/Stasi
													</option>
												</select>
											</div>
											<div class="form-group">
												<label>Status</label>
												<select
													v-model="myData.active"
													name="status"
													class="form-control"
												>
													<option value="1">Aktif</option>
													<option value="0">Non Aktif</option>
												</select>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-group">
												<label>Jenis Kelamin</label>
												<select
													v-model="myData.jk"
													name="jk"
													class="form-control digits"
												>
													<option value="L">Laki-laki</option>
													<option value="P">Perempuan</option>
												</select>
											</div>

											<div class="form-group">
												<label>No. Handphone</label>
												<input
													v-model="myData.phone"
													name="nohp"
													class="form-control"
													type="text"
												/>
											</div>
											<div
												class="form-group"
												v-show="myData.group_id == 3"
											>
												<label
													>Lingkungan/Stasi
													<span class="text-danger">*</span></label
												>
												<vue-typeahead-bootstrap
													name="lingkungan_stasi"
													data-vv-as="Lingkungan/Stasi"
													v-model="myData.lingkungan_stasi"
													:minMatchingChars="1"
													:data="lingkunganStasi"
													size="sm"
												/>
											</div>
										</div>
									</div>
									<hr />
									<div class="row">
										<div class="col">
											<div class="form-group mb-0">
												<b-button
													class="mr-3"
													type="submit"
													variant="primary"
													:disabled="isLoading"
													form="form-data"
												>
													<span
														v-show="isLoading"
														class="
															spinner-border spinner-border-sm
														"
													></span
													><i
														class="fa fa-fw fa-save"
														v-show="!isLoading"
													></i>
													Simpan
												</b-button>
												<a
													class="btn btn-danger"
													href="#"
													@click="$router.push('/pengguna')"
													>Cancel</a
												>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</px-card>
				</div>
			</div>
		</div>
		<!-- Container-fluid Ends-->
	</div>
</template>

